import React from 'react';
import styled from 'styled-components';

import { media } from '@/styles/theme';

const PageBackground = styled.div<{ $themeColor: string }>`
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  background-color: ${({ $themeColor }) => $themeColor};
`;

const BusinessHeader = styled.div`
  padding: 24px 16px 16px;
  text-align: center;

  ${media.tablet} {
    padding: 32px 24px 20px;
  }
`;

const BusinessName = styled.h1`
  margin: 0;
  font-size: 22px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.95);

  ${media.tablet} {
    font-size: 26px;
  }
`;

const WidgetArea = styled.div`
  flex: 1;
  overflow-y: auto;
  min-width: 0;

  ${media.tablet} {
    max-width: 1200px;
    width: 100%;
    margin: 0 auto;
    border-radius: 8px 8px 0 0;
  }
`;

interface HostedPageWrapperProps {
  themeColor: string;
  businessName: string;
  children: React.ReactNode;
}

export const HostedPageWrapper: React.FC<HostedPageWrapperProps> = ({
  themeColor,
  businessName,
  children,
}) => (
  <PageBackground $themeColor={themeColor}>
    <BusinessHeader>
      <BusinessName>{businessName}</BusinessName>
    </BusinessHeader>
    <WidgetArea>{children}</WidgetArea>
  </PageBackground>
);
